import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import { FadeIn, FadeOut } from "slotworks/graphics/animation/base-animations";
import deviceInfo from "slotworks/utils/device-info";
import settingsModel from "slotworks/model/settings/settings-model";

export default class FreespinsBannerTransitions extends AbstractSceneTransition {

    public in(): Contract<void> {
        const title = this.getTitle(); 
        if(!deviceInfo.isDesktop) {
            canvasManager.onOrientationChange.add(this.onOrientationChange);
            if(canvasManager.orientation == Orientation.PORTRAIT) {
                title.visible = false;
                return Contract.empty();
            }
        }
        return FadeIn(title, 600);
    }

    public out(): Contract<void> {
        const title = this.getTitle();
        if(!deviceInfo.isDesktop) {
            canvasManager.onOrientationChange.remove(this.onOrientationChange);
            if(canvasManager.orientation == Orientation.PORTRAIT) {
                return Contract.empty();
            }
        }
        return FadeOut(title, 600);
    }

    private onOrientationChange = () => {
        const title = this.getTitle();
        if(canvasManager.orientation == Orientation.PORTRAIT) {
            title.visible = false;
        } else {
            title.visible = true;
        }
    }

    private getTitle() {
        const uktitle = Layers.Banners.getSprite("288_title_freespins");
        const chtitle = Layers.Banners.getSprite("288_title_freespins_chinese");
        if(settingsModel.language == "zh-Hans") {
            uktitle.visible = false;
            return chtitle;
        } else {
            chtitle.visible = false;
            return uktitle;
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/freespins-banner-transitions.ts